import { PageHeader, Card, CardHeader, MarkdownView, ReadAloud, Badge } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { overviewSections } from '../../lib/overview';
import styles from './sections.module.css';

/** Adventure overview: GM-authored sections (prologue read-aloud) + meta. */
export function OverviewSection() {
  const ctx = useBinder();
  if (!ctx) return null;
  const { adventure } = ctx;
  const { overview, meta } = adventure;
  const sections = overviewSections(overview);

  return (
    <div>
      <PageHeader eyebrow="Panoramica" title={adventure.title} subtitle={adventure.subtitle} />

      <div className={styles.tagRow}>
        {meta.level != null && <Badge tone="gold">Livello {meta.level}</Badge>}
        {meta.playerCount && <Badge>👥 {meta.playerCount}</Badge>}
        {meta.duration && <Badge>⏳ {meta.duration}</Badge>}
      </div>

      {meta.tagline && <p className={styles.lead}>{meta.tagline}</p>}

      <div className={styles.stack}>
        {meta.setting && (
          <Card>
            <CardHeader icon="🗺️" title="Ambientazione" />
            <MarkdownView>{meta.setting}</MarkdownView>
            {meta.tone && (
              <>
                <div className={styles.blockLabel} style={{ marginTop: 'var(--space-3)' }}>
                  Tono
                </div>
                <MarkdownView>{meta.tone}</MarkdownView>
              </>
            )}
          </Card>
        )}

        {sections.map((block) => {
          if (!block.body?.trim()) return null;
          if (block.id === 'prologue') {
            return (
              <ReadAloud key={block.id} label={block.title}>
                {block.body}
              </ReadAloud>
            );
          }
          if (block.id === 'credits') {
            return (
              <p
                key={block.id}
                className={styles.entityMeta}
                style={{ textAlign: 'center', marginTop: 'var(--space-4)' }}
              >
                {block.body}
              </p>
            );
          }
          return (
            <Card key={block.id}>
              <CardHeader icon={block.icon ?? '📖'} title={block.title} />
              <MarkdownView>{block.body}</MarkdownView>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
